import { render, staticRenderFns } from "./FreeDateCard.vue?vue&type=template&id=181adfc3&scoped=true&"
import script from "./FreeDateCard.vue?vue&type=script&lang=js&"
export * from "./FreeDateCard.vue?vue&type=script&lang=js&"
import style0 from "./FreeDateCard.vue?vue&type=style&index=0&id=181adfc3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181adfc3",
  null
  
)

export default component.exports